// Placeholder Data for Digital Photography
// Your actual digital photographs from public/images/photography/
// B&W photos moved to photography-bw folder for later use

const placeholderData = [
  {
    id: 'photo-1',
    title: 'film 77430034',
    imageName: '000077430034',
    date: '2024'
  },
  {
    id: 'photo-2',
    title: 'film 78900002',
    imageName: '000078900002',
    date: '2024'
  },
  {
    id: 'photo-3',
    title: 'film 78900009',
    imageName: '000078900009',
    date: '2024'
  },
  {
    id: 'photo-4',
    title: 'film 83070001',
    imageName: '000083070001',
    date: '2024'
  },
  {
    id: 'photo-5',
    title: 'film 83070002',
    imageName: '000083070002',
    date: '2024'
  },
  {
    id: 'photo-6',
    title: 'film 83070009',
    imageName: '000083070009',
    date: '2024'
  },
  {
    id: 'photo-7',
    title: 'film 83070020',
    imageName: '000083070020',
    date: '2024'
  },
  {
    id: 'photo-8',
    title: 'film 83070030',
    imageName: '000083070030',
    date: '2024'
  },
  {
    id: 'photo-9',
    title: 'film 238780013',
    imageName: '000238780013',
    date: '2024'
  },
  {
    id: 'photo-10',
    title: 'portrait 34440015',
    imageName: '34440015',
    date: '2024'
  },
  {
    id: 'photo-11',
    title: 'street 95',
    imageName: 'ks_street-95',
    date: '2024'
  },
  {
    id: 'photo-12',
    title: 'street 98',
    imageName: 'ks_street-98',
    date: '2024'
  },
  {
    id: 'photo-13',
    title: 'street 99',
    imageName: 'ks_street-99',
    date: '2024'
  }
];

export default placeholderData;
